<template>
  <div>
    <el-alert
      title="按物料需求计算覆盖。可用库存取现存量；采购在途取草稿到货，并加上外协未到货。本单领料和移库（含草稿）先抵扣需求。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-select v-model="orderId" filterable clearable placeholder="选择工单" style="width:320px" @change="loadHistory">
        <el-option v-for="item in orderOptions" :key="item.orderId" :label="(item.orderCode || '') + ' / ' + (item.orderName || '')" :value="item.orderId" />
      </el-select>
      <el-button type="primary" :loading="loading" @click="analyze">覆盖分析并保存</el-button>
      <el-button :disabled="!orderId" @click="genSupply">生成供应建议</el-button>
    </div>

    <el-alert
      v-if="coverage.coverageCode"
      :title="'覆盖单 ' + coverage.coverageCode + ' / 工单 ' + (coverage.orderCode || '-') + ' / 需求 ' + (coverage.requirementCode || '-')"
      type="info" show-icon :closable="false" style="margin-bottom:12px"
    />

    <el-table v-if="historyList.length" :data="historyList" border size="small" style="margin-bottom:12px">
      <el-table-column prop="coverageCode" label="历史覆盖单" width="200" />
      <el-table-column prop="orderCode" label="工单" min-width="180" show-overflow-tooltip />
      <el-table-column prop="requirementCode" label="需求单" width="200" />
      <el-table-column prop="createDate" label="分析时间" width="170" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openHistory(row.coverageId)">打开</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="coverage.lines || []" border v-loading="loading">
      <el-table-column prop="productNumber" label="物料编码" width="140" />
      <el-table-column prop="productName" label="物料名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="单位" width="80" align="center">
        <template slot-scope="{ row }">{{ unitLabel(row.unit) }}</template>
      </el-table-column>
      <el-table-column prop="requiredQty" label="需求" width="100" align="right" />
      <el-table-column prop="stockQty" label="库存" width="90" align="right" />
      <el-table-column prop="inboundQty" label="采购在途" width="100" align="right" />
      <el-table-column prop="wipQty" label="在制供给" width="100" align="right" />
      <el-table-column prop="reservedQty" label="他单占用" width="100" align="right" />
      <el-table-column prop="availableQty" label="可用" width="90" align="right" />
      <el-table-column prop="shortageQty" label="缺料" width="90" align="right" />
      <el-table-column label="覆盖" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.coverageState)">{{ stateLabel(row.coverageState) }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { listMaterialCoverage, getMaterialCoverage, analyzeMaterialCoverage } from '../../api/materialCoverage'
import { generateSupplySuggestion } from '../../api/supplySuggestion'
import { selectProductionOrder } from '../../api/productionOrder'
import { listDictOptions } from '../../api/dict'

export default {
  data() {
    return {
      orderId: '',
      orderOptions: [],
      coverage: {},
      historyList: [],
      loading: false,
      units: []
    }
  },
  created() {
    this.loadOrders()
    this.loadHistory()
    listDictOptions('UNIT').then(res => { this.units = res.data || [] }).catch(() => {})
  },
  methods: {
    unitLabel(code) {
      if (!code) return ''
      const hit = this.units.find(u => String(u.id) === String(code) || u.dictValue === code || u.dictLabel === code)
      return hit ? hit.dictLabel : code
    },
    loadOrders() {
      selectProductionOrder().then(res => {
        const list = res.data || []
        this.orderOptions = list.filter(o => o.orderState !== '00' && o.orderState !== '03' && o.orderState !== '04' && o.orderState !== '06')
      }).catch(() => {})
    },
    loadHistory() {
      listMaterialCoverage({
        currentPage: 1,
        pageSize: 10,
        orderId: this.orderId || undefined
      }).then(res => {
        this.historyList = (res.data && res.data.list) || []
      })
    },
    analyze() {
      if (!this.orderId) {
        this.$message.warning('请选择工单')
        return
      }
      this.loading = true
      analyzeMaterialCoverage({ orderId: this.orderId }).then(res => {
        this.coverage = res.data || {}
        this.$message.success('已分析并保存 ' + (this.coverage.coverageCode || ''))
        this.loadHistory()
      }).finally(() => { this.loading = false })
    },
    genSupply() {
      if (!this.orderId) return
      generateSupplySuggestion({ orderId: this.orderId }).then(res => {
        const code = res.data && res.data.suggestionCode
        this.$message.success('已生成供应建议 ' + (code || ''))
        this.analyze()
      })
    },
    openHistory(id) {
      getMaterialCoverage(id).then(res => {
        this.coverage = res.data || {}
        this.orderId = this.coverage.orderId || this.orderId
      })
    },
    stateLabel(s) {
      return { COVERED: '已覆盖', PARTIAL: '部分', SHORT: '缺料' }[s] || s
    },
    stateType(s) {
      return { COVERED: 'success', PARTIAL: 'warning', SHORT: 'danger' }[s] || 'info'
    }
  }
}
</script>
